import { ReactComponent as UploadIcon } from '../../assets/icons/upload.svg'

export default UploadIcon
